import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Menu } from 'antd';
import { MenuItemProps } from 'antd/lib/menu/MenuItem';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';

const MenuItem = styled(Menu.Item)`
  span {
    flex: 1;
  }
`;

const BaseDelete: FC<MenuItemProps> = (params) => {
  const { danger = true, icon = <TrashCan16 />, children } = params;

  return (
    <MenuItem danger={danger} icon={icon} {...params}>
      {children || <FormattedMessage id="delete" />}
    </MenuItem>
  );
};

export const Delete = withHideIfNotAllowed(BaseDelete);
